export default __webpack_public_path__ + "static/media/fasthors.65b5d781.jfif";